import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable({
  providedIn: 'root',
})
export class InteractorService {
  public InvalidImageFrmt:boolean=false;
  public isImageSizeExceed:boolean=false;
  public agencyData = new BehaviorSubject<object>(null);
  public agencyCast = this.agencyData.asObservable(); // agency api recall

  public showAgencyGrid = new BehaviorSubject<boolean>(true);
  public showAgencyCast = this.showAgencyGrid.asObservable(); // show/hide agency list

  public startLoader = new BehaviorSubject<boolean>(false);
  public loaderCast = this.startLoader.asObservable(); // trigger loader in case of api call

  public collaborationEditData = new BehaviorSubject<object>(null);
  public collaborationEditCast = this.collaborationEditData.asObservable(); // send collaboration edit data

  public helperRefresh = new BehaviorSubject<boolean>(null);
  public helperRefreshCast = this.helperRefresh.asObservable(); // helper tab click event

  public agencyRefresh = new BehaviorSubject<boolean>(null);
  public agencyRefreshCast = this.agencyRefresh.asObservable();

  public collRefresh = new BehaviorSubject<boolean>(null);
  public collRefreshCast = this.collRefresh.asObservable();

  public personIndex = new BehaviorSubject<string>(null);
  public personIndexCast = this.personIndex.asObservable();

  public reportingunitData = new BehaviorSubject<object>(null);
  public reportingunitCast = this.reportingunitData.asObservable(); // RU api recall

  public reportingunitRefresh = new BehaviorSubject<boolean>(null);
  public reportingunitRefreshCast = this.reportingunitRefresh.asObservable();

  public CollaborationagencyData = new BehaviorSubject<object>(null);
  public CollaborationagencyCast = this.CollaborationagencyData.asObservable(); // RU api recall

  public CollaborationagencyRefresh = new BehaviorSubject<boolean>(null);
  public CollaborationagencyRefreshCast = this.CollaborationagencyRefresh.asObservable();

  public optionsData = new BehaviorSubject<boolean>(null);
  public optionsCast = this.optionsData.asObservable();

  public helperUserData = new BehaviorSubject<object>(null);
  public helperUserCast = this.helperUserData.asObservable(); // Helper api recall

  public helperUserRefresh = new BehaviorSubject<boolean>(null);
  public helperUserRefreshCast = this.helperUserRefresh.asObservable();

  public PermissionData = new BehaviorSubject<object>(null);
  public PermissionCast = this.PermissionData.asObservable();

  public errorData = new BehaviorSubject<boolean>(null);
  public errorCast = this.errorData.asObservable();

  public redirectAfterReview = new BehaviorSubject<boolean>(false);
  public redirectAfterReviewCast = this.redirectAfterReview.asObservable();

  public brandingDetails = new BehaviorSubject<object>(null);
  public brandingDetailsCast = this.brandingDetails.asObservable();
  public inviteToCompleteBrandingDetails = new BehaviorSubject<object>(null);
  public inviteToCompleteBrandingDetailsCast = this.inviteToCompleteBrandingDetails.asObservable();

  public notificationType = new BehaviorSubject<string>(null);

  public searchAgencyData = new BehaviorSubject<object>(null);
  public searchAgencyCast = this.searchAgencyData.asObservable();

  constructor() {}


  changeBrandingDetails(newData){
    this.brandingDetails.next(newData);
  }
  changeInviteToCompleteBrandingDetails(newData){
    this.inviteToCompleteBrandingDetails.next(newData);
  }

  /**
   * refresh agency list
   * @param any newList
   */
  changeAgencyList(newList) {
    this.agencyData.next(newList);
  }

  /**
   * refresh permission list
   * @param any newList
   */
  changePermissionData(newList) {
    this.PermissionData.next(newList);
  }

  /**
   * set agency grid status
   * @param any status
   */
  changeAngencyGridstatus(status) {
    this.showAgencyGrid.next(status);
  }

  /**
   * set loader status
   * @param any status
   */
  changeLoaderStatus(status) {
    this.startLoader.next(status);
  }

  /**
   * set the collaboration edit data
   * @param any data
   */
  changeCollaborationEditData(data) {
    this.collaborationEditData.next(data);
  }

  /**
   * triggers when helper tab is clicked
   * @param any value
   */
  changeHelperTabStatus(value) {
    this.helperRefresh.next(value);
  }

  /**
   * Triggers when agency tab is clicked
   * @param any value
   */
  changeAgencyTabStatus(value) {
    this.agencyRefresh.next(value);
  }

  /**
   * Triggers when collobration tab is clicked
   * @param any value
   */
  changeCollTabStatus(value) {
    this.collRefresh.next(value);
  }

  /**
   * Set Person Index
   */
  setPersonIndex(id) {
    this.personIndex.next(id);
  }

  /**
   * refresh RU list
   * @param any newList
   */
  changeReportingUnitList(newList) {
    this.reportingunitData.next(newList);
  }

  /**
   * Triggers when RU tab is clicked
   * @param any value
   */
  changeReportingunitTabStatus(value) {
    this.reportingunitRefresh.next(value);
  }

  /**
   * refresh Partner collaboration list
   * @param any newList
   */
  changeCollaborationAgencyList(newList) {
    this.CollaborationagencyData.next(newList);
  }

  /**
   * Triggers when collaboration Agency tab is clicked
   * @param any value
   */
  changeCollaborationAgencyTabStatus(value) {
    this.CollaborationagencyRefresh.next(value);
  }

  /**
   * triggers when helper tab is clicked
   * @param any value
   */
  changeOptionsTabStatus(value) {
    this.optionsData.next(value);
  }
  /**
   * refresh helper user details
   * @param any newList
   */
  changeHelperUserDataList(newList) {
    this.helperUserData.next(newList);
  }

  /**
   * Triggers when helper tab is clicked
   * @param any value
   */
  changeHelperUserDataTabStatus(value) {
    this.helperUserRefresh.next(value);
  }

  /**
   * redirect route to Notification Tab
   * @param any type
   */
  changeToNotificationTab(type) {
    this.notificationType.next(type);
  }

  setErrorFlag(flag) {
    this.errorData.next(flag);
  }

  redirectAfterReviewStatus(value) {
    this.redirectAfterReview.next(value);
  }

  /**
   * refresh Search Agency list
   * @param any newList
   */
  changeSerachAgencyList(newList) {
    this.searchAgencyData.next(newList);
  }
  isSizeExceeded(file: any, maxSize:number) {
    const fileSize = file.size;
    const fileMb = file.size / 1024 ** 2;
    if (maxSize && fileMb > maxSize) {
      this.isImageSizeExceed=true;
        return false;
    } else {
      this.isImageSizeExceed=false;
        return true;
    }
}
isValidFormat(file: any,allowedExtension:any) {
  let extension = file.name.split('.').pop();
  if (extension) {
      if (allowedExtension.includes(extension.toLowerCase())) {
        this.InvalidImageFrmt=false
          return true;
      } else {
        this.InvalidImageFrmt=true
          return false;
      }
  } else {
    this.InvalidImageFrmt=true
      return false;
  }
}
}
